module.exports = __webpack_public_path__ + "img/combination-cloud.94f75e9.svg";